"use client"

import React from "react";
import {getDateWithDayShort, getTime} from "@/helpers/dateHelper";
import {Event, eventStatusSchema} from "@vereinsheim/backend-types/src/event";
import TeamTag from "@/app/pwa/components/team/TeamTag";
import {pwaTeamEventsPath} from "@/utils/urlHelper";
import {useTeams} from "@/app/pwa/lib/pwa-context";
import Info from "@/assets/icon/info.svg";


interface EventDetailsHeaderProps {
  event: Event
}

export function EventDetailsHeader({ event }: EventDetailsHeaderProps) {
  const rawTeams = useTeams()
  const eventTeams = rawTeams.filter(t => event.teamIds?.includes(t.Id?.toString() ?? ""))

  const isCanceled = event.status === eventStatusSchema.enum.canceled;
  return (
    <div className="pb-4 border-t border-gray-150 pt-space-y space-y-space-y">
      {eventTeams.length >= 1 &&
        <div className="flex gap-1 flex-wrap whitespace-nowrap">
          { eventTeams.map(team =>
            team.Id &&
            <TeamTag key={team.Id} href={pwaTeamEventsPath(team.Id?.toString())} team={team} />
          )}
        </div>
      }
      <div>
        <h2 className={`text-xl font-semibold mt-2 ${isCanceled ? "line-through decoration-2" : ""}`}>
          {event.title}
        </h2>
        <div className="flex items-center gap-2 mt-0.5">
          <span className="font-semibold">{getDateWithDayShort(event.start / 1000)}</span>
          <div className="w-0.5 h-4 bg-gray-150"></div>
          <span className="">{getTime(event.start)} Uhr</span>
        </div>
        {event.location  && 
          <div className="mt-0.5">Ort: {event.location}</div>
        }
        { isCanceled && 
          <div className="text-warning font-semibold flex items-center gap-0.5 w-full py-1 mt-2 border-t border-b border-warning justify-center"><Info className="w-4 h-4" />Abgesagt</div>
        }

      </div>
    </div>
  );
}
